module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/5-c98f30c8f7c9f3e33fa4fae381cdf7a3.webp";